import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceEvent } from '@atlassian/experience-tracker';

import { type Experience } from '../aifc-experience-collect-helpers';
import { collectAllWithSubExperienceAttributes } from '../aifc-experience-collect-helpers/collectAllWithSubExperienceAttributes';
import { failExperienceOnSubExperienceFail } from '../aifc-experience-collect-helpers/failExperienceOnSubExperienceFail';

/**
 * Create a collect function for the AIFC_CREATE_IN_CHAT experience.
 * This function will collect the AIFC_MESSAGE and PREVIEW_CARD_RENDER experiences and mirror their success/fail/abort events to the parent experience.
 * If AIFC_ALL_DATA_HANDLED or PREVIEW_CONTENT fails, it will fail the parent experience.
 *
 * @returns A collect function for the AIFC_CREATE_IN_CHAT experience
 */
export const createAifcCreateInChatExperienceCollect = () => {
	const subExperienceCollect = collectAllWithSubExperienceAttributes([
		ExperienceName.AIFC_MESSAGE,
		ExperienceName.PREVIEW_CARD_RENDER,
	]);
	return (events: ExperienceEvent[], experience: Experience): void => {
		// these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
		failExperienceOnSubExperienceFail(ExperienceName.AIFC_ALL_DATA_HANDLED, experience, events);
		failExperienceOnSubExperienceFail(ExperienceName.PREVIEW_CONTENT, experience, events);

		subExperienceCollect(events, experience);
	};
};
